import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/login', name: 'LoginPage', meta: { title: '反馈系统 Program Feedback' }, component: () => import('@/views/loginPage') }, // 学生登陆页面
  { path: '/adviserLogin', name: 'adviserLogin', meta: { title: '反馈系统' }, component: () => import('@/views/adviserLogin') }, // 顾问个人中心
  { path: '/pilotCourseLogin', name: 'pilotCourseLogin', meta: { title: '登录' }, component: () => import('@/views/pilotCourseLogin') }, // 先导课登录
  { path: '/resetPassword', name: 'resetPassword', meta: { title: '忘记密码' }, component: () => import('@/views/resetPassword') }, // 忘记密码
  { path: '/adviserHomePage', name: 'adviserHomePage', meta: { title: '反馈系统' }, component: () => import('@/views/adviserHomePage') }, // 顾问首页
  { path: '/bindingStudents', name: 'bindingStudents', meta: { title: '绑定新学员' }, component: () => import('@/views/bindingStudents') }, // 绑定学生
  { path: '/', name: 'PersonalDetails', meta: { title: '反馈系统 Program Feedback' }, component: () => import('@/views/personalDetails') }, // 学生中心
  { path: '/personalProjectList', name: 'PersonalProjectList', meta: { title: '反馈系统' }, component: () => import('@/views/personalProjectList') }, // 个人项目
  { path: '/projectDetails', name: 'ProjectDetails', meta: { title: '项目反馈 Program Feedback' }, component: () => import('@/views/projectDetails') }, // 项目详情
  { path: '/paperDetail', name: 'PaperDetail', meta: { title: '项目反馈' }, component: () => import('@/views/paperDetail') }, // 论文项目详情
  { path: '/planB/paperDetail', name: 'paperDetailnew', meta: { title: '项目反馈' }, component: () => import('@/views/paperDetailnew') }, // 论文项目新详情
  { path: '/paperDelivery', name: 'PaperDelivery', meta: { title: '投递反馈' }, component: () => import('@/views/paperDelivery') }, // 论文投递
  { path: '/informationMessage', name: 'informationMessage', component: () => import('@/views/informationMessage') },
  { path: '/leavingMessage', name: 'LeavingMessage', component: () => import('@/views/leavingMessage') },
  { path: '*', redirect: { name: 'login' } }
]

const router = new VueRouter({ mode: 'history', routes })
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta ? to.meta.title : '反馈系统'
  }
  next()
})
export default router
